"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getter_1 = require("./getter");
var decorator_1 = require("./decorator");
function booleanOr(root, path, decorators, orElse) {
    if (path === void 0) { path = ''; }
    if (decorators === void 0) { decorators = []; }
    if (orElse === void 0) { orElse = false; }
    var raw = Boolean(getter_1.getDefinedOrElse(root, path, orElse));
    return decorator_1.decorate(raw, decorators);
}
exports.booleanOr = booleanOr;
//# sourceMappingURL=booleanOr.js.map